import{css}from'glamor';export var item=css({cursor:'pointer'}).toString();export var selected=css({fontWeight:500});